export default __webpack_public_path__ + "static/media/video.d1ffc2d5.gif";